// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as ReactAria from "react-aria";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactStately from "react-stately";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OverlayTriggerView from "../overlays/OverlayTriggerView.res.js";
import * as $$Date from "@internationalized/date";

function makeStyle(focused, editable, placeholder) {
  let color = focused ? "#a01e72" : (
      placeholder ? "#bdbdca" : "#25243a"
    );
  return {
    backgroundColor: focused ? "#f4e4ee" : "inherit",
    color: color,
    minWidth: editable ? "2ch" : "default",
    padding: editable ? "4px 1px" : "3px 1px",
    textAlign: "center",
    borderRadius: "3px",
    caretColor: "transparent"
  };
}

let make = React.memo(props => {
  let value = props.value;
  let match = React.useState(() => false);
  let setFocused = match[1];
  let domRef = React.useRef(null);
  let match$1 = ReactAria.useDateSegment(value, props.state, domRef);
  let props$1 = ReactAria.mergeProps(match$1.segmentProps, {
    style: makeStyle(match[0], value.isEditable && value.type !== "literal", value.isPlaceholder),
    onFocus: param => setFocused(param => true),
    onBlur: param => setFocused(param => false)
  });
  let newrecord = {...props$1};
  return JsxRuntime.jsx("div", (newrecord.ref = Primitive_option.some(domRef), newrecord.children = value.text, newrecord));
});

function internationalizationDatetimeFromJsDateObj(jsDate) {
  return new $$Date.Time(jsDate.getHours(), jsDate.getMinutes());
}

function internationalizationDatetimeToJsDateObj(time) {
  let today = new Date();
  return new Date(today.getFullYear(), today.getMonth(), today.getDate(), time.hour | 0, time.minute | 0);
}

let style = {
  cursor: "text",
  display: "flex"
};

function InputTimeField(props) {
  let onChange = props.onChange;
  let initialValue = props.value;
  let __required = props.required;
  let label = props.label;
  let required = __required !== undefined ? __required : false;
  let match = React.useState(() => Stdlib_Option.map(initialValue, internationalizationDatetimeFromJsDateObj));
  let setValue = match[1];
  let value = match[0];
  let match$1 = React.useState(() => false);
  let setFocused = match$1[1];
  let focused = match$1[0];
  let match$2 = Hover.use(undefined, undefined, undefined);
  let ref = match$2[0];
  let onFocusChange = React.useCallback(value => setFocused(param => value), []);
  let props_locale = Stdlib_Option.getOr(props.testLocalization, I18n.locale);
  let props_aria$label = Stdlib_Option.getOr(label, I18n.t("time"));
  let props_onChange = value => {
    let value$1 = (value == null) ? undefined : Primitive_option.some(value);
    setValue(param => value$1);
    if (!(value == null)) {
      return onChange(internationalizationDatetimeToJsDateObj(value));
    }
  };
  let props_onFocus = props.onFocus;
  let props_onBlur = props.onBlur;
  let props$1 = {
    locale: props_locale,
    shouldForceLeadingZeros: true,
    "aria-label": props_aria$label,
    value: value,
    onChange: props_onChange,
    onFocusChange: onFocusChange,
    onFocus: props_onFocus,
    onBlur: props_onBlur
  };
  let state = ReactStately.useTimeFieldState(props$1);
  let match$3 = ReactAria.useTimeField(props$1, state, ref);
  let fieldProps = match$3.fieldProps;
  ReactUpdateEffect.use1(() => {
    if (!focused && Stdlib_Option.isNone(value)) {
      state.setValue(null);
    }
  }, [focused]);
  let fieldProps$1 = ReactAria.mergeProps(fieldProps, {
    style: ReactAria.mergeProps(fieldProps.style, style)
  });
  let newrecord = {...fieldProps$1};
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(OverlayTriggerView.make, {
      children: JsxRuntime.jsx("div", (newrecord.style = style, newrecord.children = state.segments.map((segment, index) => JsxRuntime.jsx(make, {
        value: segment,
        state: state
      }, index.toString())), newrecord)),
      preset: {
        NAME: "inputField",
        VAL: {
          required: required,
          errorMessage: props.errorMessage
        }
      },
      growContent: true,
      label: label,
      hideIcon: true,
      hovered: match$2[1],
      focused: focused
    }),
    ref: Primitive_option.some(ref)
  });
}

let make$1 = React.memo(InputTimeField);

export {
  internationalizationDatetimeFromJsDateObj,
  internationalizationDatetimeToJsDateObj,
  make$1 as make,
}
/* make Not a pure module */
